import { FlatList, View, Text } from 'react-native'
import { translate } from '../../../i18n'
import { styles } from './LeaderBoardList.style'
import { Item } from './partial/Item/Item'
import { useMemo } from 'react'
import { buildPlayerColorMap } from '../../../utils/playerColors'

export interface LeaderboardPlayer {
  playerId: string
  playerName?: string
  isLeft?: boolean | null
  isRemovedByTeacher?: boolean | null
  chips?: number
  metaLabel?: string
}

interface LeaderboardListProps {
  players: ReadonlyArray<LeaderboardPlayer>
  myPlayerId: string | undefined
}

export const LeaderboardList = ({ players, myPlayerId }: LeaderboardListProps) => {

  const playerColorMap = useMemo(
    () => buildPlayerColorMap(players.map((p) => p.playerId)),
    [players]
  )

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={styles.rankSection}>
          <Text style={styles.text}>{translate('leaderboard.rank')}</Text>
        </View>
        <View style={styles.userSection}>
          <Text style={styles.text}>{translate('leaderboard.user')}</Text>
        </View>
        <View style={styles.chipsSection}>
          <Text style={styles.text}>{translate('leaderboard.chips')}</Text>
        </View>
      </View>
      <FlatList
        style={styles.list}
        data={players}
        renderItem={({ index, item }) =>
          item ? (
            <Item
              player={item}
              isHighlighted={item.playerId === myPlayerId}
              index={index}
              color={playerColorMap.get(item.playerId) || 'Brand/Maroon'}
            />
          ) : null
        }
      />
    </View>
  )
}
